module.exports = __webpack_public_path__ + "img/notification.d01f57a3.svg";